import React from "react";
import {withStyles, Checkbox} from "@material-ui/core";

export default withStyles({
    root: {
        color: "#FAFAFA",
        '&$checked': {
            color: "#43425D",
        },
    },
    checked: {}
})(props => <Checkbox color="default" {...props} />);

